
let cssCargado = false; // ensures we only add the CSS once

export function aplicarBrandingTenant(config) {
	// Set page title
	if (config.tituloPagina) document.title = config.tituloPagina;

	// Set favicon
	if (config.favicons && config.favicons.length) {

		// Remove existing dynamic favicons
		const existingLinks = document.querySelectorAll(
			"link[data-dynamic-favicon]"
		);

		existingLinks.forEach(link => link.remove());

		// Add each favicon dynamically
		config.favicons.forEach(icon => {
			const link = document.createElement("link");

			link.rel = icon.rel || "icon";

			// Only set type when it is provided.
			// For normal PNG favicons, image/png is appropriate.
			if (icon.type) {
				link.type = icon.type;
			} else if (!icon.rel || icon.rel === "icon") {
				link.type = "image/png";
			}

			if (icon.sizes) {
				link.sizes = icon.sizes;
			}

			// IMPORTANT:
			// Use icon.href, not config.favicon32x32
			link.href = `${process.env.PUBLIC_URL}/${config.tenant}/img/${icon.href}`;

			link.setAttribute("data-dynamic-favicon", "true");

			document.head.appendChild(link);
		});
	}

	if (cssCargado) return; // already loaded


	const existing = document.getElementById("css-root-style");
	if (existing) existing.remove();

	const linkTag = document.createElement("link");
	linkTag.id = "css-root-style";
	linkTag.rel = "stylesheet";
	linkTag.href = `${process.env.PUBLIC_URL}/${config.tenant}/css/${config.tenant}.css`;

	document.head.appendChild(linkTag);

	cssCargado = true;
}